import { isBefore } from "date-fns"

import { isDev, isStagingEnv } from "src/constants/env"
import { storeUrl } from "src/constants/hrefs"
import { TParadiseQuote } from "src/data/paradise/paradiseQuotes/paradiseQuoteTypes"

export function generateQuoteLink(quoteId: string, shippingCountry: string) {
  if (isDev || isStagingEnv) {
    return `${storeUrl.staging}/quote/${quoteId}?shipping_country=${shippingCountry}`
  }

  return `${storeUrl.production}/quote/${quoteId}?shipping_country=${shippingCountry}`
}

export function isQuoteExpired(quote: TParadiseQuote) {
  return (
    quote.status !== "purchased" &&
    isBefore(new Date(quote.expires_at), new Date())
  )
}
